<template>
   <div>
     <div v-if="showAddtoWatchlist">
       <!-- <svg @click.stop="watchListHander" id="watchlist_add" data-name="watchlist add" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
       <g id="Ellipse_5" data-name="Ellipse 5" transform="translate(27 27) rotate(180)" :stroke="stokeColor ? '#D0292A' : '#FECA35'" stroke-width="1">
    <circle cx="13.5" cy="13.5" r="13.5" stroke="none"/>
    <circle cx="13.5" cy="13.5" r="13" fill="none"/>
    </g>
  <path id="Union_4" data-name="Union 4" d="M2.085,13.266A2.085,2.085,0,0,1,0,11.181v-9.1A2.085,2.085,0,0,1,2.085,0h9.1a2.085,2.085,0,0,1,2.085,2.085v9.1a2.085,2.085,0,0,1-2.085,2.085ZM1.9,2.085v9.1a.19.19,0,0,0,.19.19h9.1a.19.19,0,0,0,.19-.19v-9.1a.19.19,0,0,0-.19-.19h-9.1a.19.19,0,0,0-.189.19Zm3.98,7.2v-1.9H3.98a.758.758,0,1,1,0-1.516h1.9V3.98a.758.758,0,1,1,1.516,0v1.9h1.9a.758.758,0,1,1,0,1.516h-1.9v1.9a.758.758,0,1,1-1.516,0Z" transform="translate(6.867 6.867)" fill="#fff"/>
</svg> -->
<svg  @click.stop="watchListHander" id="watchlist_add" width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_b_792_2500)">
<circle cx="24" cy="24" r="24" fill="white" fill-opacity="0.3"/>
</g>
<path d="M25.9456 20.7565H12.9726C12.2591 20.7565 11.6753 21.3403 11.6753 22.0538C11.6753 22.7673 12.2591 23.3511 12.9726 23.3511H25.9456C26.6591 23.3511 27.2429 22.7673 27.2429 22.0538C27.2429 21.3403 26.6591 20.7565 25.9456 20.7565ZM25.9456 15.5673H12.9726C12.2591 15.5673 11.6753 16.1511 11.6753 16.8646C11.6753 17.5781 12.2591 18.1619 12.9726 18.1619H25.9456C26.6591 18.1619 27.2429 17.5781 27.2429 16.8646C27.2429 16.1511 26.6591 15.5673 25.9456 15.5673ZM32.4321 25.9457V22.0538C32.4321 21.3403 31.8483 20.7565 31.1348 20.7565C30.4212 20.7565 29.8375 21.3403 29.8375 22.0538V25.9457H25.9456C25.232 25.9457 24.6483 26.5295 24.6483 27.243C24.6483 27.9565 25.232 28.5403 25.9456 28.5403H29.8375V32.4322C29.8375 33.1457 30.4212 33.7295 31.1348 33.7295C31.8483 33.7295 32.4321 33.1457 32.4321 32.4322V28.5403H36.3239C37.0375 28.5403 37.6212 27.9565 37.6212 27.243C37.6212 26.5295 37.0375 25.9457 36.3239 25.9457H32.4321ZM12.9726 28.5403H20.7564C21.4699 28.5403 22.0537 27.9565 22.0537 27.243C22.0537 26.5295 21.4699 25.9457 20.7564 25.9457H12.9726C12.2591 25.9457 11.6753 26.5295 11.6753 27.243C11.6753 27.9565 12.2591 28.5403 12.9726 28.5403Z" fill="white"/>
<defs>
<filter id="filter0_b_792_2500" x="-6" y="-6" width="60" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feGaussianBlur in="BackgroundImageFix" stdDeviation="3"/>
<feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_792_2500"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_792_2500" result="shape"/>
</filter>
</defs>
</svg>
  </div>

    <div v-if="!showAddtoWatchlist">
      <svg @click.stop="watchListHander" id="watchlist_remove" data-name="watchlist remove" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
      <g id="Ellipse_5" data-name="Ellipse 5" transform="translate(27 27) rotate(180)" :stroke="stokeColor ? '#D0292A' : '#FECA35'" stroke-width="1">
    <circle cx="13.5" cy="13.5" r="13.5" stroke="none"/>
    <circle cx="13.5" cy="13.5" r="13" fill="none"/>
  </g>
  <path id="Union_4" data-name="Union 4" d="M2.085,13.266A2.085,2.085,0,0,1,0,11.181v-9.1A2.085,2.085,0,0,1,2.085,0h9.1a2.085,2.085,0,0,1,2.085,2.085v9.1a2.085,2.085,0,0,1-2.085,2.085ZM1.9,2.085v9.1a.19.19,0,0,0,.19.19h9.1a.19.19,0,0,0,.19-.19v-9.1a.19.19,0,0,0-.19-.19h-9.1a.19.19,0,0,0-.189.19Zm3.98,5.306H3.98a.758.758,0,1,1,0-1.516H9.286a.758.758,0,1,1,0,1.516H5.875Z" transform="translate(6.867 6.867)" fill="#fff"/>
</svg>

    </div>
</div>
</template>
<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/eventBus";
import { getDatabase, ref, onValue } from "firebase/database";
import FirebaseActions from "@/mixins/FirebaseActions";
import Redirection from "@/mixins/redirection.js";
import googleAnalytics from "@/mixins/googleAnalytics.js";
import { _projectName } from "@/provider-config.js";
import { showSnackBar } from '../../utilities';
export default {
  props: {
    content: {
      type: Object,
    },
    width: {
      type: String,
    },
    height: {
      type: String,
    },
    screen: {
      type: Object,
    },
  },
  data() {
    return {
      showAddtoWatchlist: true,
      action: null,
      fillColor: null,
      colorCodeActive: '#FECA35',
      colorCodeDeactive: '#FFFFFF',
      BackCodeActive: '#FECA35',
      BackCodeDeactive: null,
      watchlistFlag: false,
      stokeColor: false,
      localDisplayLang: null

    };
  },
  watch: {
    content() {
      this.fetchButtonState();
    },
    subscriberid() {
      if (this.subscriberid) {
        this.fetchButtonState();
      }
    },
  },
  computed: {
    ...mapGetters(["subscriberid", "profileid"]),
  },
  mounted () {
    this.stokeColor = localStorage.getItem('theme') == 'theme-light' ? true : false;
    this.localDisplayLang = localStorage.getItem("setDisplayLanguageCode");
    this.localDisplayLang = this.localDisplayLang == 'eng' ? 'en' : this.localDisplayLang;
  },
  created() {
    this.fetchButtonState();
    this.fillColor =
      _projectName === "VLIVE"
        ? "#FF9600"
        : _projectName === "NET5"
        ? "#FF9600"
        : _projectName === "NAMMAFLIX"
        ? "#ffffff"
        : _projectName === "Noor Play"
        ? "#ec1c65"
        : "";
  },
  methods: {
   
    watchListHander () {
      if (this.subscriberid) {
       this.watchlistFlag = !this.watchlistFlag;
        if (this.showAddtoWatchlist) {
          this.addToWatchList()
          showSnackBar(this.$t('Added to watchlist'))

        } else {
          showSnackBar(this.$t('removed from watchlist'))

          this.removeFromWatchlist()
        } 
      } else {
        this.redirectToLogin(this.localDisplayLang);
        // let payload = {
        //   state: true,
        //   formType: "lookup",
        // };
        // eventBus.$emit("authPopup", payload);
      }
    },
    fetchButtonState() {
      if (!this.subscriberid) {
        this.showAddtoWatchlist = true;
        return;
      }

      if (!this.content) return;

      const content = this.content;
      const db = getDatabase();
      let path = `/subscriber/${this.subscriberid}/${this.profileid}/content/`;

      if ("seriesid" in content && content.seriesid) {
        path += `${content.objectid}/episodes/${content.objectid}`;
      } else {
        path += `${content.objectid}`;
      }

      const contentRef = ref(db, path);

      onValue(contentRef, (snapshot) => {
        const response = snapshot.val();

        if (response?.inwatchlist === true) {
          this.showAddtoWatchlist = false;
          this.action = "REMOVE";
        } else {
          this.showAddtoWatchlist = true;
          this.action = "ADD";
        }

        // console.log("watchlist action", this.action);
      }, (error) => {
        console.error("Error fetching watchlist state:", error);
      });
    },
    addToWatchList() {
      if (this.subscriberid) {
        this.showAddtoWatchlist = false;
        // this.content.orientation = this.screen.displayType;
        this.updateContentWatchlist(this.content, true);
        // if (this.action == "ADD") {
        //   console.log("update with add");
        //   this.updateContentWatchlist(this.content, true);
        // } else if (this.action == "REMOVE") {
        //   console.log("update with remove");
        //   this.updateContentWatchlist(this.content, false);
        // }

        //logging watchlist google analytics event.
        let GA = {
          action_name: "Add to watchlist",
        };
        this.userActionEvent(GA);
      } else {
        this.redirectToLogin(this.localDisplayLang);
        // let payload = {
        //   state: true,
        //   formType: "lookup",
        // };
        // eventBus.$emit("authPopup", payload);
      }
    },
    removeFromWatchlist() {
      if (this.subscriberid) {
        this.showAddtoWatchlist = true;
        this.updateContentWatchlist(this.content, false);

        //logging watchlist google analytics event.
        let GA = {
          action_name: "Remove from watchlist",
        };
        this.userActionEvent(GA);
      }
    },
  },
  mixins: [FirebaseActions, googleAnalytics, Redirection],
};
</script>


<style lang="scss">
@import "./watchListBtn.scss";
@import "@/sass/_variables.scss";

.iconouterfill{
  fill:$like-icon-outerfill
}

@media only screen and (min-width: 1000px) {
    #watchlist_add:hover g { 
      fill:$clr-likebutton-hover;
  }
}

</style>